<script>
import { mapActions } from 'vuex';
import i18n from '@/plugins/i18n';

export default {
    props: {
        selectedCompanyId: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            description: null,
        }
    },

    watch: {
        description(newVal, oldVal) {
            if (newVal == null) newVal = '';
            if (oldVal == null) oldVal = '';

            if (newVal.length >= oldVal.length) {
                const el = window.document.getElementById('textArea');
                if (el) {
                    if (el.clientHeight < el.scrollHeight) {
                        el.style.height = `${10 + el.scrollHeight}px`;
                    }
                } else {
                    el.style.height = '100px';
                }
            }

            if (newVal.includes('  ')) {
                this.description = newVal.replace('  ', ' ');
            }
        }
    },

    mounted() {
        this._getAboutCompany();
    },

    methods: {
        ...mapActions('auditor', [
            'getAboutCompany',
        ]),

        _getAboutCompany() {
            this.getAboutCompany({ audited_company_id: this.selectedCompanyId })
                .then(res => {
                    this.description = res.data.description != null && res.data.description != undefined ? res.data.description : '';
                })
                .finally(() => {
                    const el = window.document.getElementById('textArea');
                    if (el) {
                        if (el.clientHeight < el.scrollHeight) {
                            el.style.height = `${10 + el.scrollHeight}px`;
                        }
                    } else {
                        el.style.height = '100px';
                    }
                })
        },
    }
}
</script>

<template>
    <div class="about-the-company">
        <textarea id="textArea" rows="4" v-model="description"
            maxlength="5000"
            disabled
        ></textarea>
    </div>
</template>

<style lang='scss' scoped>
.about-the-company {
    width: 100%;
    height: fit-content;
}

textarea {
    min-height: 100px !important;
    width: 100%;
    padding: .5em;
    border-radius: .25em;
    border: 0 !important;
    outline-width: 0;

    background-color: whitesmoke;

    &:focus {
        outline-style: solid;
        outline-width: .125em;
        background-color: rgb(234, 234, 234);
    }
}
</style>